<template>
  <div
    :id="id"
    class="board"
    :style="reflect_result_2"
    @dragover.prevent
    @drop.prevent="drop"
  >
    <slot />
  </div>
</template>

<script>

export default {
  props:{
    id:Object,
    srcImg:String
  },
  //値を参照する為に追加
  data() {
    return {
      which: true,
      card_idd: 0,
      board_idd: 0,
      images: [
        {
          num: 1,
          src: require(".././assets/puzzle/puzzle3/puzzle3_1.jpg"),
        },
        {
          num: 2,
          src: require(".././assets/puzzle/puzzle3/puzzle3_2.jpg"),
        },
        {
          num: 3,
          src: require(".././assets/puzzle/puzzle3/puzzle3_3.jpg"),
        },
        {
          num: 4,
          src: require(".././assets/puzzle/puzzle3/puzzle3_4.jpg"),
        },
      ],
    };
  },
  methods: {
    hello() {
      console.log("hello");
    },
    //ここあとで変更する必要あり
    loadImg() {
      return require(`../assets/puzzle/puzzle3/${this.srcImg}`);
    },
    drop(e) {
      const card_id = e.dataTransfer.getData("card_id");
      const card = document.getElementById(card_id);

      card.style.display = "block";
      e.target.appendChild(card);

      const target_board = e.target.id;

      //"card-1" →"1" という風に変換
      var var_card_id = card_id;
      var num_card_id = var_card_id.substr(5, 6);

      this.card_idd = num_card_id;

      //"board-2"→"2"となるように変換
      var var_target_board = target_board;
      var num_board_id = var_target_board.substr(6, 7);
      this.board_idd = num_board_id;

    }, //drop(e)  終了

  },

  //computedは値が変更されるごとに行われる処理を書く
  computed: {
    reflect_result_2: function() {
      var a = this.card_idd;
      var num_a = parseInt(a);
      var b = this.board_idd;
      var num_b = parseInt(b);
      var c = -1;

      if ([num_a + c] == num_b) {
        if (num_b == 0) {
          this.$store.commit('much_pass',1)
          return {
            backgroundImage: "url(" + require(".././assets/puzzle/puzzle3/puzzle3_1.jpg") + ")",
            backgroundSize: "cover",
          };
        } else if (num_b == 1) {
          this.$store.commit('much_pass',2)
          return {
            backgroundImage: "url(" + require(".././assets/puzzle/puzzle3/puzzle3_2.jpg") + ")",
            backgroundSize: "cover",
          };
        } else if (num_b == 2) {
          this.$store.commit('much_pass',3)
          return {
            backgroundImage: "url(" + require(".././assets/puzzle/puzzle3/puzzle3_3.jpg") + ")",
            backgroundSize: "cover",
          };
        } else if (num_b == 3) {
          this.$store.commit('much_pass',4)
          return {
            backgroundImage: "url(" + require(".././assets/puzzle/puzzle3/puzzle3_4.jpg") + ")",
            backgroundSize: "cover",
          };
        } else {
          return {
            backgroundColor: "blue",
            backgroundSize: "cover",
          };
        }
      } else {
        return {
          backgroundImage: "url(" + this.loadImg() + ")",
          backgroundSize: "cover",
        };
      }
    },
  },
  created() {
    this.current = this.images[0];
    this.show.src = this.current.src;
  },
};
</script>

<style>
.board {
  border-style: solid;
  border-color: aqua;
  background-image: url(`${this.srcImg}`);
  background-size: "cover";
}
</style>
